import { Monitor, Gamepad2, Users, Car, Glasses, Zap } from "lucide-react";

export function setupIcon(id) {
  if (id === "pc_gaming") return Monitor;
  if (id === "ps5_duo") return Users;
  if (id === "ps5_steering") return Car;
  if (id === "ps5_vr") return Glasses;
  if (id === "ps5_vr_steering") return Zap;
  return Gamepad2;
}
